module.exports = __webpack_public_path__ + "static/media/world-map.b3a84ef2.png";